/*@ngInject*/
const ServerAckRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.ack = function () {
        const url = '/rest/Session/ack';

        return this.get(url);
    };
};

angular.module('umCore')
    .service('serverAckRepository', ServerAckRepository);
